import { Dispatch, SetStateAction } from "react";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import { useDataChanged } from "../Contexts/DataChangedProvider";
import { useSelectedTab } from "../Contexts/SelectedTabProvider";
import "./TableTabs.css";

interface TableTabsProps {
  setSaveOpen: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
}

const TableTabs = (props: TableTabsProps) => {
  const { selectedTab, setSelectedTab, setPreselectedTab } = useSelectedTab();
  const { dataChanged } = useDataChanged();

  const TableTab = ({ name }: { name: string }) => (
    <ButtonComponent
      name={name}
      selected={selectedTab}
      onClick={() => {
        if (dataChanged) {
          setPreselectedTab(name);
          props.setSaveOpen(true);
        } else {
          setSelectedTab(name);
        }
      }}
      isDisabled={props.disabled}
    />
  );

  return (
    <div className="tableTabs">
      <TableTab name="Budget" />
      <TableTab name="FTE" />
      <TableTab name="Sumár - Zjednotená kategória" />
      <TableTab name="Sumár - Zložky mzdy" />
      <TableTab name="Sumár - ASIS/Legislatíva/Projekt" />
      <TableTab name="Summary FTE" />
      <TableTab name="Original Budget" />
      <TableTab name="Original FTE" />
      <TableTab name="History Budget" />
      <TableTab name="History FTE" />
    </div>
  );
};

export default TableTabs;
